import { getContentByLocale } from "../content";
import { useI18n } from "../i18n";
import { PageSeo } from "../components/seo/PageSeo";
import { MapView } from "../views/home/MapView";

export function MapPage() {
  const { locale } = useI18n();
  const content = getContentByLocale(locale);

  return (
    <>
      <PageSeo
        title={`${content.map.title} | ${content.seo.defaultTitle}`}
        description={`${content.map.region} - ${content.map.locations.join(" • ")}`}
      />
      <MapView
        title={content.map.title}
        region={content.map.region}
        image={content.map.image}
        imageAlt={content.map.imageAlt}
        locations={content.map.locations}
      />
    </>
  );
}
